class FormInput {
  constructor() {
    this._init();
  }
  _init() {
    const input = document.querySelectorAll('.wpcf7-form-control');
    input.forEach((element) => {
      element.addEventListener('click', () => {
        const label =
          element.parentElement?.parentElement?.querySelector('label');
        label?.classList.add('content');
      });
      element.addEventListener('blur', (event) => {
        this.clickInput(element);
      });
    });
  }

  clickInput(elt) {
    const label = elt.parentElement?.parentElement?.querySelector('label');
    if (elt.value.length > 0) {
      label?.classList.add('content');
    } else {
      label?.classList.remove('content');
    }
  }
}
export let formInput = new FormInput();
